import {
  getDocumentRedirectionInfoAction,
  getServiceRequestInfoAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {
  Lease_Settlement_Quote_Allowed_List,
  SERVICE_REQUEST_TYPE_BY_VIEW,
} from '../../../utils/constant';
import {isServiceRequestAllowed} from '../../../utils/roleAccess';
import {Navigate, OpenWebURL} from '../../../utils/util';
import DocTypesForContractFiltering from '../../documentDownload/raiseDownloadRequest/DocTypesForContractFiltering.json';
import quickActionsConfig from './QuickActions.json';

import GetHelpIcon from '../../../assets/svg/get_help_action.svg';
import RaiseRequestIcon from '../../../assets/svg/raise_request_quick_action.svg';
import DocumentRequestIcon from '../../../assets/svg/request_quick_action.svg';
import SmartlineIcon from '../../../assets/svg/smartline_quick_action.svg';

import {Card} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './QuickActions.css';

const iconMapping = {
  language: <img src={SmartlineIcon} alt="" />,
  serviceRequest: <img src={RaiseRequestIcon} alt="" />,
  raiseRequest: <img src={RaiseRequestIcon} alt="" />,
  document: <img src={DocumentRequestIcon} alt="" />,
  help: <img src={GetHelpIcon} alt="" />,
};

const QuickActions = (props) => {
  const {t} = useTranslation();
  const actions = quickActionsConfig[props.country]?.actions ?? [];

  const isSettlementQuoteAllowed = () =>
    (props.contracts ?? []).some((contract) =>
      Lease_Settlement_Quote_Allowed_List[props.country]?.includes(
        contract.productLine
      )
    );

  const isDocumentAvailable = (docType) => {
    const docsForCountry = DocTypesForContractFiltering[props.country] ?? {};
    const activeProductLines = new Set(
      (props.contracts ?? []).map((contract) => contract.productLine)
    );
    const pastProductLines = new Set(
      (props.pastContracts ?? []).map((contract) => contract.productLine)
    );

    const availableFromActive = [...activeProductLines].some(
      (productLine) =>
        docsForCountry[productLine]?.includes(docType) &&
        docType !== 'LIEN_DE_REGISTRATION_LETTERS'
    );
    const availableFromPast = [...pastProductLines].some(
      (productLine) =>
        docsForCountry[productLine]?.includes(docType) &&
        (docType === 'LIEN_DE_REGISTRATION_LETTERS' || docType === 'FINAEN')
    );
    return availableFromActive || availableFromPast;
  };

  const isActionAllowedForRole = (action) => {
    const viewKey =
      action.actionType === 'document' ? 'download' : action.target;
    const requestType = SERVICE_REQUEST_TYPE_BY_VIEW[viewKey];
    return (
      !requestType ||
      isServiceRequestAllowed(props.role, requestType, props.roleAccess)
    );
  };

  const isActionVisible = (action) => {
    if (action.disabled || !isActionAllowedForRole(action)) {
      return false;
    }
    switch (action.condition) {
      case 'settlementQuote':
        return isSettlementQuoteAllowed();
      case 'document':
        return isDocumentAvailable(action.target);
      default:
        return true;
    }
  };

  const handleActionClick = (action) => {
    switch (action.actionType) {
      case 'externalUrl':
        OpenWebURL('weburl', action.url);
        break;
      case 'serviceRequest':
        appStore.dispatch(
          getServiceRequestInfoAction({selectedRequestType: action.target})
        );
        Navigate('serviceRequest');
        break;
      case 'document':
        appStore.dispatch(
          getDocumentRedirectionInfoAction({selectedDocType: action.target})
        );
        Navigate('download');
        break;
      case 'navigate':
      default:
        Navigate(action.target);
    }
  };

  const visibleActions = actions.filter(isActionVisible);

  if (visibleActions.length === 0) {
    return null;
  }

  return (
    <div className="quick-actions-container">
      <div className="quick-actions-title">{t('QUICK_ACTIONS')}</div>
      <div className="quick-actions-card-container">
        {visibleActions.map((action) => (
          <Card
            key={action.item}
            id={`quickAction-${action.item}`}
            className="quick-action-card"
            role="button"
            tabIndex={0}
            onClick={() => handleActionClick(action)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleActionClick(action);
              }
            }}
          >
            <span className="quick-action-icon">
              {iconMapping[action.icon] ?? iconMapping.help}
            </span>
            <span className="quick-action-label" title={t(action.label)}>
              {t(action.label)}
            </span>
          </Card>
        ))}
      </div>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contracts: state.appStates.contractNumbers?.contracts,
    pastContracts: state.appStates.contractNumbers?.pastContracts,
    role: state.appStates.role,
    roleAccess: state.appStates.roleAccess,
  };
};

export default connect(mapStateToProps)(QuickActions);
